import moment from 'moment'
export const DateHelper = {
    formalDate(date){
        return moment(date).format('dddd, MMM D')
    },
    formatDate(date){
        return moment(date).format('MM/DD/YYYY')
    }
}